module.exports = __webpack_public_path__ + "static/media/AngularJS_logo.9c7fc40f.png";